import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { Usermanagement } from '../modal';

export default function reducer(state: Usermanagement = new Usermanagement(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.USER_MGMT_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.USER_MGMT_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.USER_MGMT_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
